<div class="rfe-default-office">

	<div class="notice-info">
		<p class="rfe-default-office-intro">
			<svg width="1em" class="svg-middle" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
				<use xlink:href="@Assets/svg/symbol-defs.svg#file-invoice" />
			</svg>
			{{ $t('vm.components.popin.default-office-rfe.intro') }}
		</p>
	</div>

	<p class="rfe-default-office-lead">
		<strong>{{ $t('vm.components.popin.default-office-rfe.lead') }}</strong>
	</p>

	<div class="rfe-default-office-list">
		<radio-frame v-for="item in offices" :key="item.id"
					 :id="'default-office-' + item.id"
					 default-class="p-like" name="default-office"
					 :radio-value="item.id"
					 :title="officeName(item)"
					 v-model="ofiId">{{ officeName(item) }}</radio-frame>
	</div>

	<p class="text-sm">
		<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
			<use xlink:href="@Assets/svg/symbol-defs.svg#check-circle" />
		</svg>
		{{ $t('vm.components.popin.default-office-rfe.note') }}
	</p>

</div>
